import React from 'react';

import type { UserState } from './index';

export const UserContext = React.createContext<UserState>({} as UserState);
